import { Navigate } from 'react-router-dom';
import { CreateCompanyStepper } from '../components/create-company/CreateCompanyStepper';
import { Card } from '@startuptools/ui/Card';
import { Stack } from '@startuptools/ui/Stack';
import { Typography } from '@startuptools/ui/Typography';
import { Trans } from '@lingui/react';
import { useCurrentUserSuspenseQuery } from '../graphql/react-operations';
import { useNavigate } from '../components/Navigate';

export const OnboardingCreateCompany = () => {
  const { changeCompany } = useNavigate();
  const {
    data: { currentUser: user },
  } = useCurrentUserSuspenseQuery();

  if (!user.name || !user.email) {
    return <Navigate to="../profile" replace />;
  }

  return (
    <Stack gap={2} width="100%" maxWidth={1000}>
      <Typography level="h2">
        <Trans id="Welcome to Bolago, {name}!" values={{ name: user.name?.split(' ')[0] ?? user.email }} />
      </Typography>
      <Card sx={{ maxWidth: 1000, width: '100%' }}>
        <CreateCompanyStepper navigateToCompany={id => changeCompany(id)} />
      </Card>
    </Stack>
  );
};
